import React from 'react';

const UserManualIcon = () => (
  <svg
    id="User_Manual_icon"
    data-name="User Manual icon"
    xmlns="http://www.w3.org/2000/svg"
    width="25.519"
    height="27.431"
    viewBox="0 0 25.519 27.431"
  >
    <path
      id="Path_1629"
      data-name="Path 1629"
      d="M19.936,21.493V18A1.939,1.939,0,0,0,19,19.661V35.726a3.905,3.905,0,0,1,.939-.381V21.493Z"
      transform="translate(-16.982 -15.7)"
      fill="none"
    />
    <path
      id="Path_1630"
      data-name="Path 1630"
      d="M36.454,28.89V17.573H23.4v17.5h6.488a7.076,7.076,0,0,1,6.571-6.178ZM33.578,21.3A1.008,1.008,0,0,1,32.571,22.3H27.385a1.007,1.007,0,1,1,0-2.014h5.185A1.007,1.007,0,0,1,33.578,21.3Zm-7.956,4.374a1.007,1.007,0,0,1,0-2.014h8.713a1.007,1.007,0,0,1,1.007,1.007,1.02,1.02,0,0,1-1.007,1.007H25.621Z"
      transform="translate(-18.428 -15.559)"
      fill="none"
    />
    <path
      id="Path_1631"
      data-name="Path 1631"
      d="M42.275,37.563a5.036,5.036,0,0,0-.647-.127c-.011,0-.022,0-.034,0a.993.993,0,0,1-.22-.026c-.118-.008-.235-.017-.355-.017a5.046,5.046,0,1,0,4.928,6.121,5.029,5.029,0,0,0-3.672-5.954Zm-.592,2.39a.584.584,0,0,1-.183.444.763.763,0,0,1-.965,0,.628.628,0,0,1,0-.882.768.768,0,0,1,.97,0A.58.58,0,0,1,41.683,39.953Zm-1.26,5.59V41.1h1.19v4.44Z"
      transform="translate(-22.56 -22.072)"
      fill="none"
    />
    <path
      id="Path_1632"
      data-name="Path 1632"
      d="M20.071,48.576a1.008,1.008,0,0,1,1.007-1.007H28.7a6.98,6.98,0,0,1-.214-.939h-7.54a1.946,1.946,0,0,0,0,3.892h9.569a7.153,7.153,0,0,1-.8-.939H21.078A1.007,1.007,0,0,1,20.071,48.576Z"
      transform="translate(-16.982 -25.106)"
      fill="none"
    />
    <path
      id="Path_1633"
      data-name="Path 1633"
      d="M42.6,48.306v.729h1.19V48.027Z"
      transform="translate(-24.738 -25.565)"
      fill="#b95700"
    />
    <path
      id="Path_1634"
      data-name="Path 1634"
      d="M35.2,52.257a7.066,7.066,0,0,0,7.031-6.479l-2.1.493a5.04,5.04,0,0,1-8.861,2.079L27.2,49.3h2.262a7.153,7.153,0,0,0,.8.939H23.2L18.25,51.4a3.936,3.936,0,0,0,2.447.853Z"
      transform="translate(-16.737 -24.826)"
      fill="#b95700"
    />
    <path
      id="Path_1635"
      data-name="Path 1635"
      d="M43.792,42.916H42.6v3.711l1.19-.279Z"
      transform="translate(-24.738 -23.886)"
      fill="#eb6909"
    />
    <path
      id="Path_1636"
      data-name="Path 1636"
      d="M42.676,40.467a.628.628,0,0,0,0,.882.763.763,0,0,0,.965,0,.627.627,0,0,0,0-.882.768.768,0,0,0-.97,0Z"
      transform="translate(-24.704 -23.024)"
      fill="#eb6909"
    />
    <path
      id="Path_1637"
      data-name="Path 1637"
      d="M19.957,48.093a1.946,1.946,0,0,1,0-3.892H27.5a6.98,6.98,0,0,0,.214.939H20.092a1.007,1.007,0,0,0,0,2.014h6.369l4.061-.953a5.025,5.025,0,0,1,.634-6.964l-3.034.712a7.007,7.007,0,0,0-.67,2.238H20.964v-.559L18.95,42.1v.221a3.906,3.906,0,0,0-.939.381v-.381L16,42.794v3.353a3.951,3.951,0,0,0,1.513,3.107l4.949-1.161Z"
      transform="translate(-15.997 -22.677)"
      fill="#eb6909"
    />
    <path
      id="Path_1638"
      data-name="Path 1638"
      d="M49.149,42.175a5.072,5.072,0,0,1-.118,1.076l2.1-.494c.015-.192.029-.385.029-.582A7.04,7.04,0,0,0,48.4,36.583l-3.039.713A5.047,5.047,0,0,1,49.149,42.175Z"
      transform="translate(-25.644 -21.805)"
      fill="#eb6909"
    />
    <path
      id="Path_1639"
      data-name="Path 1639"
      d="M39.532,28.483l-3.293.773h2.316A1.006,1.006,0,0,0,39.532,28.483Z"
      transform="translate(-22.648 -19.143)"
      fill="#5f9501"
    />
    <path
      id="Path_1640"
      data-name="Path 1640"
      d="M18.011,33.679,16,34.152v6.816l2.014-.473Z"
      transform="translate(-15.997 -20.851)"
      fill="#5f9501"
    />
    <path
      id="Path_1641"
      data-name="Path 1641"
      d="M20.4,33.12v6.816l2.014-.473V32.647Z"
      transform="translate(-17.442 -20.512)"
      fill="#5f9501"
    />
    <path
      id="Path_1642"
      data-name="Path 1642"
      d="M39.957,32.112a7.061,7.061,0,0,0-5.9,3.941l3.034-.712a5.016,5.016,0,0,1,3.3-1.236c.12,0,.237.009.355.017a.993.993,0,0,0,.22.026c.012,0,.023,0,.034,0a5.036,5.036,0,0,1,.647.127l3.039-.713a7.055,7.055,0,0,0-2.713-1.284v-4.9l-2.014.473Z"
      transform="translate(-21.93 -18.781)"
      fill="#5f9501"
    />
    <path
      id="Path_1643"
      data-name="Path 1643"
      d="M22.409,29.312V22.5l-2.014.473v6.816Z"
      transform="translate(-17.442 -17.176)"
      fill="#79b61d"
    />
    <path
      id="Path_1644"
      data-name="Path 1644"
      d="M18.011,23.528,16,24v6.816l2.014-.473Z"
      transform="translate(-15.997 -17.515)"
      fill="#79b61d"
    />
    <path
      id="Path_1645"
      data-name="Path 1645"
      d="M42.844,24.518l2.014-.473V17.23l-2.014.473Z"
      transform="translate(-24.818 -15.446)"
      fill="#79b61d"
    />
    <path
      id="Path_1646"
      data-name="Path 1646"
      d="M35.938,27.641a1.007,1.007,0,0,0-1.007-1.007H26.218a1.007,1.007,0,1,0,0,2.014h6.4l3.293-.773A1,1,0,0,0,35.938,27.641Z"
      transform="translate(-19.024 -18.536)"
      fill="#79b61d"
    />
    <path
      id="Path_1647"
      data-name="Path 1647"
      d="M28.845,21.619a1.007,1.007,0,1,0,0,2.014h5.185a1.007,1.007,0,0,0,0-2.014Z"
      transform="translate(-19.887 -16.888)"
      fill="#79b61d"
    />
    <path
      id="Path_1648"
      data-name="Path 1648"
      d="M18.011,18.534a1.939,1.939,0,0,1,.939-1.657v3.489l2.014-.473V16.587H34.023v.242l2.014-.472V15.58a1.008,1.008,0,0,0-1.007-1.007H19.957A3.965,3.965,0,0,0,16,18.534v2.525l2.014-.473Z"
      transform="translate(-15.997 -14.573)"
      fill="#c8d200"
    />
  </svg>
);

export default UserManualIcon;
